// pb-korting.js — Probio Noord klantkorting helper
// Wordt geladen na pb-korting-init (die window.PBNiveau zet)
(function(){
  var niveau = window.PBNiveau || '';
  var tabelReiniging   = {brons:10, zilver:15, goud:20};
  var tabelPapier      = {brons:2,  zilver:5,  goud:7};
  var tabelPoetslappen = {brons:5,  zilver:7,  goud:10};
  var tabelDispensers  = {brons:0,  zilver:3,  goud:5};
  var grReinig   = ['Reinigingsmiddelen','Allesreinigers','Sanitairreinigers','Glasreinigers','Desinfectiemiddelen','Vloerreinigers','Handzeep','Luchtverfrissers','Zeep & handdesinfectie','Keuken & horeca reiniging','Persoonlijke verzorging'];
  var grPoets    = ['Poetslappen'];
  var grDisp     = ['Dispensers','Zeepdispensers','Papierdispensers'];
  var grPapier   = ['Toiletpapier','Handdoekpapier','Poetspapier','Poetsrollen & industriedoeken','Afvalzakken','Afvalbakken','Handschoenen','Doeken & sponzen','Emmers & werkwagens','Mophoezen / vlakmoppen'];

  window.PBKorting = {
    niveau: niveau,
    pct: function(type, vendor) {
      if(!niveau) return 0;
      var groep = '';
      if(vendor === 'Vikan')                  groep = 'papier';
      else if(grReinig.indexOf(type)  > -1)   groep = 'reiniging';
      else if(grPoets.indexOf(type)   > -1)   groep = 'poetslappen';
      else if(grDisp.indexOf(type)    > -1)   groep = 'dispensers';
      else if(grPapier.indexOf(type)  > -1)   groep = 'papier';
      if(!groep) return 0;
      if(groep === 'reiniging')   return tabelReiniging[niveau]   || 0;
      if(groep === 'poetslappen') return tabelPoetslappen[niveau] || 0;
      if(groep === 'dispensers')  return tabelDispensers[niveau]  || 0;
      if(groep === 'papier')      return tabelPapier[niveau]      || 0;
      return 0;
    }
  };
})();